import React, { useCallback, useEffect, useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { PlusLg } from 'react-bootstrap-icons'
import { Link, useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify'
import classNames from 'classnames'

import gear from '../../assets/icons/gear.png'
import ListNoItems from '../../components/_atoms/ListNoItems/ListNoItems'
import ListPagination from '../../components/_atoms/ListPagination/ListPagination'
import SalesButton from '../../components/_atoms/SalesButton/SalesButton'
import SalesText from '../../components/_atoms/SalesText/SalesText'
import ModalChangeCarData from '../../components/_molecules/ModalChangeCarData/ModalChangeCarData'
import { ModalChangeBrand } from '../../components/_molecules/ModalChangeBrand/ModalChangeBrand'
import { ModalChangeCondition } from '../../components/_molecules/ModalChangeCondition/ModalChangeCondition'
import { ModalChangePrice } from '../../components/_molecules/ModalChangePrice/ModalChangePrice'
import { ModalChangeWarehouseLocation } from '../../components/_molecules/ModalChangeWarehouseLocation/ModalChangeWarehouseLocation'
import { ModalChangeDimensionsAndWeight } from '../../components/_molecules/ModalChangeDimensionsAndWeight/ModalChangeDimensionsAndWeight'
import ModalChangePartTypeData from '../../components/_molecules/ModalChangePartType/ModalChangePartType'
import ModalCustomizableColumns from '../../components/_molecules/ModalCustomizableColumns/ModalCustomizableColumns'
import ModalDataDocument from '../../components/_molecules/ModalDataDocument/ModalDataDocument'
import ModalEditPart from '../../components/_molecules/ModalEditPart/ModalEditPart'
import { ModalFastDeal } from '../../components/_molecules/ModalFastDeal/ModalFastDeal'
import ModalIncomingInvoiceOpen from '../../components/_molecules/ModalIncomingInvoiceOpen/ModalIncomingInvoiceOpen'
import ModalLinkingToCar from '../../components/_molecules/ModalLinkingToCar/ModalLinkingToCar'
import ModalLinkToWarehouse from '../../components/_molecules/ModalLinkToWarehouse/ModalLinkToWarehouse'
import ModalMarketplaces from '../../components/_molecules/ModalMarketplaces/ModalMarketplaces'
import { ModalPartsBulkApply } from '../../components/_molecules/ModalPartsBulkActions/ModalPartsBulkApply'
import { ModalPartsBulkConfirm } from '../../components/_molecules/ModalPartsBulkActions/ModalPartsBulkConfirm'
import NavigationButtons from '../../components/_molecules/NavigationButtons/NavigationButtons'
import SearchComponent from '../../components/_molecules/SearchComponent/SearchComponent'
import TablePartList from '../../components/_orgamisms/TablePartList/TablePartList'
import { pages } from '../../constants/parts/navigationButtonsPages'
import { colors, fontSizes, fontWeights } from '../../constants/salesStyles'
import useResetFiltersOnUnmount from '../../hooks/partList/useResetFiltersOnUnmount'
import { ToastType, useToast } from '../../hooks/useToast'
import DatahubApiService from '../../modules/api/DatahubApiService'
import getCarById from '../../modules/redux/createUpdateForm/getCarById'
import getIncomingInvoicesByPartsId from '../../modules/redux/documentList/GetIncomingInvoicesByPartsId'
import GetPartsIdByDocumentId from '../../modules/redux/documentList/GetPartsIdByDocumentId'
import getPartsMarketplacesCount from '../../modules/redux/partList/GetPartsMarketplacesCount'
import loadPartList from '../../modules/redux/partList/LoadPartList'
import setSellPartModal from '../../modules/redux/partList/SetSellPartModal'
import updatePartsMarketplaces from '../../modules/redux/partList/UpdatePartsMarketplaces'
import getMarketplacesInfo from '../../modules/redux/sales/getMarketplacesInfo'
import loadMarketplacesList from '../../modules/redux/sales/loadMarketplacesList'
import getUserActiveColumnsPartList from '../../modules/redux/userSettings/GetUserActiveColumnsPartList'
import warehousesSelectSearch from '../../modules/redux/warehouseList/WarehousesSelectSearch'
import { useDispatch } from '../../modules/store/customDispatch'
import { useSelector } from '../../modules/store/customSelector'
import { useSetPartsArchivedStatusHandlerMutation } from '../../modules/store/datahubApi/datahubApi'
import { storeDispatchTypes } from '../../modules/store/storeDispatchTypes'
import { adminRouteAlias, getAdminNavigationPath } from '../../router/adminRouteAlias'
import { EDocumentType } from '../../types/document/documentTypes'
import { Part, PartListPageParams, PartListSearchParams, Marketplaces, MarketplacesKeys } from '../../types/part/partTypes'

import styles from './styles.module.scss'

const PartList = () => {
    const params = useParams<PartListPageParams>()
    const dispatch = useDispatch()
    const currentPart = useSelector(state => state.partList.currentPart)
    const customizableColumns = useSelector(state => state.partList.customizableColumns)

    // Модалки
    const [isEditModalOpen, setIsEditModalOpen] = useState(false)
    const [isSellPartsModalOpen, setIsSellPartsModalOpen] = useState(false)
    const [isDataDocumentModalOpen, setIsDataDocumentModalOpen] = useState(false)
    const [isIncomingInvoicePartsModalOpen, setIsIncomingInvoicePartsModalOpen] = useState(false)
    const [isLinkingToCarPartsModalOpen, setIsLinkingToCarPartsModalOpen] = useState(false)
    const [isMarketplacesModalOpen, setIsMarketplacesModalOpen] = useState(false)
    const [isCustomizableColumnsModalOpen, setIsCustomizableColumnsModalOpen] = useState(false)
    const [isChangeCarDataModalOpen, setIsChangeCarDataModalOpen] = useState(false)
    const [isChangePartTypeDataModalOpen, setIsChangePartTypeDataModalOpen] = useState(false)
    const [isChangePartWarehouseDataModalOpen, setIsChangePartWarehouseDataModalOpen] = useState(false)
    const [isChangeDimensionsAndWeightModalOpen, setIsChangeDimensionsAndWeightModalOpen] = useState(false)
    const [isChangeConditionModalOpen, setIsChangeConditionModalOpen] = useState(false)
    const [isChangeBrandModalOpen, setIsChangeBrandModalOpen] = useState(false)
    const [isChangePriceModalOpen, setIsChangePriceModalOpen] = useState(false)
    const [isChangeWarehouseLocationModalOpen, setIsChangeWarehouseLocationModalOpen] = useState(false)

    const location = useLocation()
    const navigate = useNavigate()
    let pagesParts = pages

    // Параметры поиска
    const [partListSearchParams, setPartListSearchParams] = useState<PartListSearchParams>({})
    const [searchParams, setSearchParams] = useSearchParams()
    const [searchParamsLoaded, setSearchParamsLoaded] = useState(0)
    const searchParamCarId = searchParams.get('carId')
    const searchParamPage = searchParams.get('p')
    const searchParamFilterDate = searchParams.get('d')
    const searchParamFilterDateField = searchParams.get('dField')
    const searchParamWarehouseId = searchParams.get('wh')
    const searchParamPartName = searchParams.get('pn')
    const searchParamCategoryId = searchParams.get('g')
    const searchParamConditionId = searchParams.get('conditionId')
    const searchParamTypeId = searchParams.get('typeId')
    const searchParamMarkId = searchParams.get('markId')
    const searchParamModelId = searchParams.get('modelId')
    const searchParamPriceFrom = searchParams.get('priceFrom')
    const searchParamPriceTo = searchParams.get('priceTo')
    const searchParamPartNumber = searchParams.get('partNumber')
    const searchParamSortOrder = searchParams.get('sortOrder')
    const searchParamDocumentId = searchParams.get('documentId')
    const searchParamWithPrice = searchParams.get('withPrice')
    const searchParamWithPhoto = searchParams.get('withPhoto')
    const searchParamWithDescription = searchParams.get('withDescription')
    const searchParamWithPartNumber = searchParams.get('withPartNumber')
    const searchParamWithMarkModelModificationAndTypeId = searchParams.get('withMarkModelModificationAndTypeId')
    const searchParamWithCarId = searchParams.get('withCarId')
    const searchParamWithAvitoFullInfo = searchParams.get('withAvitoFullInfo')
    const searchParamWarehouseSection = searchParams.get('warehouseSection')
    const searchParamWarehousePlace = searchParams.get('warehousePlace')
    const searchParamQuantityFrom = searchParams.get('quantityFrom')
    const searchParamQuantityTo = searchParams.get('quantityTo')
    const searchParamMarketplace = searchParams.get('marketplace')

    // Car filter
    const carFilter = useSelector(state => state.partList.filters.car)
    const page = useSelector(state => state.partList.filters.page)
    const perPage = useSelector(state => state.partList.filters.perPage)

    const navigateWithParams = (partId = '') => {
        const queryParams = new URLSearchParams(location.search)

        if (partId) {
            if (params.partId !== partId) {
                navigate(`/admin/parts/${partId}?${queryParams.toString()}`)
            }
        } else {
            navigate(`/admin/parts?${queryParams.toString()}`)
        }
    }

    const filterPartsByDate = (date: string) => {
        dispatch({
            type: storeDispatchTypes.setFilterDateFilterParts,
            value: {
                filterDate: date,
            },
        })
    }

    const filterPartsByDateField = (field: string) => {
        dispatch({
            type: storeDispatchTypes.setFilterDateFieldFilterParts,
            value: {
                filterDateField: field,
            },
        })
    }

    const filterPartsByPartName = (partName: string) => {
        dispatch({
            type: storeDispatchTypes.setPartNameTextFilterParts,
            value: {
                partName: partName,
            },
        })
    }

    const filterPartsByCategoryId = (categoryId: string) => {
        dispatch({
            type: storeDispatchTypes.setCategoryFilterParts,
            value: {
                filterId: categoryId,
            },
        })
    }

    const filterPartsByConditionId = (conditionId: string) => {
        dispatch({
            type: storeDispatchTypes.setConditionFilterParts,
            value: {
                filterId: conditionId,
            },
        })
    }

    const filterPartsByTypeId = (typeId: string) => {
        dispatch({
            type: storeDispatchTypes.setTypeFilterParts,
            value: {
                filterId: typeId,
            },
        })
    }

    const filterPartsByWarehouseId = (warehouseId: string) => {
        dispatch({
            type: storeDispatchTypes.setFilterWarehouseIdParts,
            value: {
                warehouseId: warehouseId,
            },
        })
    }

    const filterPartsByMarketplace = (marketplace: MarketplacesKeys | null) => {
        dispatch({
            type: storeDispatchTypes.setPartListParamsMarketplace,
            value: {
                marketplace: marketplace,
            },
        })
    }

    const filterPartsByMarkId = (markId: string) => {
        dispatch({
            type: storeDispatchTypes.setMarkFilterParts,
            value: {
                filterId: markId,
            },
        })
    }

    const filterPartsByModelId = (modelId: string) => {
        dispatch({
            type: storeDispatchTypes.setModelFilterParts,
            value: {
                filterId: modelId,
            },
        })
    }

    const filterPartsByPriceRange = (priceFrom: string | null, priceTo: string | null) => {
        dispatch({
            type: storeDispatchTypes.setPriceRangeParts,
            value: {
                from: priceFrom,
                to: priceTo,
            },
        })
    }

    const filterPartsByPartNumber = (partNumber: string) => {
        dispatch({
            type: storeDispatchTypes.setPartNumberFilterParts,
            value: {
                filterId: partNumber,
            },
        })
    }

    const filterPartsBySortOrder = (sortField: string, sortOrder: string) => {
        dispatch({
            type: storeDispatchTypes.setPartListSort,
            value: {
                sortField,
                sortOrder,
            },
        })
    }

    const setCurrentPart = (currentPart?: Part) => {
        dispatch({
            type: storeDispatchTypes.setCurrentPart,
            value: currentPart,
        })
    }

    const openEditModal = (part: Part) => {
        if (!isSellPartModalOpen) {
            navigateWithParams(part.id)
            setIsEditModalOpen(true)
        }

        dispatch({
            type: storeDispatchTypes.setCurrentPart,
            value: part,
        })
    }

    const handleClose = () => {
        if (!isSellPartModalOpen) {
            navigateWithParams()
            setIsEditModalOpen(false)
        }
    }

    const { part: soldPart, isOpen: isSellPartModalOpen } = useSelector(state => state.partList.sellPartModal)
    const isLoading = useSelector(state => state.partList.isLoading.partList)
    const parts = useSelector(state => state.partList.partList.data)

    const userId = useSelector(state => state.userData.smsAuth.userId)

    // Sort
    const sortOrder = useSelector(state => state.partList.sortOrder)

    //Select search filter
    const modelId = useSelector(state => state.partList.filters.modelId)
    const markId = useSelector(state => state.partList.filters.markId)
    const categoryId = useSelector(state => state.partList.filters.categoryId)
    const conditionId = useSelector(state => state.partList.filters.conditionId)
    const typeId = useSelector(state => state.partList.filters.typeId)
    const partId = useSelector(state => state.partList.filters.partId)
    const partNumber = useSelector(state => state.partList.filters.partNumber)
    const warehouseSection = useSelector(state => state.partList.filters.warehouseSection)
    const warehousePlace = useSelector(state => state.partList.filters.warehousePlace)

    // search filter part title
    const partName = useSelector(state => state.partList.filters.partName)

    // Range Filters
    const priceRange = useSelector(state => state.partList.filters.priceRange)
    const priceFrom = useSelector(state => state.partList.filters.priceRange?.from)
    const priceTo = useSelector(state => state.partList.filters.priceRange?.to)

    const yearRange = useSelector(state => state.partList.filters.yearRange)
    const yearFrom = useSelector(state => state.partList.filters.yearRange?.from)
    const yearTo = useSelector(state => state.partList.filters.yearRange?.to)

    const quantityRange = useSelector(state => state.partList.filters.quantityRange)
    const quantityFrom = useSelector(state => state.partList.filters.quantityRange?.from)
    const quantityTo = useSelector(state => state.partList.filters.quantityRange?.to)

    const filterDate = useSelector(state => state.partList.filters.filterDate)
    const filterDateField = useSelector(state => state.partList.filters.filterDateField)
    const filterWarehouseId = useSelector(state => state.partList.filters.warehouseId)
    const filterVendorCode = useSelector(state => state.partList.filters.filterVendorCode)

    const documentId = useSelector(state => state.partList.filters.document?.documentId)
    const withPrice = useSelector(state => state.partList.filters.withPrice)
    const withPhoto = useSelector(state => state.partList.filters.withPhoto)
    const withDescription = useSelector(state => state.partList.filters.withDescription)
    const withPartNumber = useSelector(state => state.partList.filters.withPartNumber)
    const withMarkModelModificationAndTypeId = useSelector(
        state => state.partList.filters.withMarkModelModificationAndTypeId,
    )
    const withCarId = useSelector(state => state.partList.filters.withCarId)
    const withAvitoFullInfo = useSelector(state => state.partList.filters.withAvitoFullInfo)
    const marketplace = useSelector(state => state.partList.filters.marketplace)
    const warehousesSS = useSelector(state => state.warehouseList.warehousesSS)

    // Counts
    const [counts, setCounts] = useState<Record<string, number>>()
    const itemsCount = useSelector(state => state.partList.partList.dataCount)
    const itemsTotal = useSelector(state => state.partList.partList.total)
    const draftCount = useSelector(state => state.partList.partList.draftCount)
    const archivedCount = useSelector(state => state.partList.partList.archivedCount)
    const soldCount = useSelector(state => state.partList.partList.soldCount)

    useEffect(() => {
        if (!isLoading) {
            setCounts({
                itemsTotal,
                draftCount,
                archivedCount,
                soldCount,
            })
        }
    }, [isLoading, itemsTotal, draftCount, archivedCount, soldCount])

    useEffect(() => {
        pagesParts = pagesParts.map(page => ({
            ...page,
            count: counts && counts[page.countKey],
        }))
    }, [counts])

    // load parts list data
    const loadParts = async () => {
        let partsId: string[] | undefined = undefined
        if (documentId) {
            await dispatch(GetPartsIdByDocumentId(documentId)).then(result => {
                partsId = Array.from(new Set(result))
            })
        }

        const partListSearchParams: PartListSearchParams = {
            carId: carFilter?.carId,
            modelId,
            markId,
            groupId: categoryId,
            conditionId,
            typeId,
            search: partName,
            priceRange: priceRange && { from: priceFrom, to: priceTo },
            yearRange: yearRange && { from: yearFrom, to: yearTo },
            quantityRange: quantityRange && { from: quantityFrom, to: quantityTo },
            partId: partId || partsId,
            partNumber,
            filterDate,
            filterDateField,
            warehouseId: filterWarehouseId,
            withPrice,
            withPhoto,
            withDescription,
            withPartNumber,
            withMarkModelModificationAndTypeId,
            withCarId,
            withAvitoFullInfo,
            warehouseSection,
            warehousePlace,
            marketplace,
        }

        setPartListSearchParams(partListSearchParams)

        dispatch(
            loadPartList({
                pagination: {
                    page,
                    perPage,
                },
                order: sortOrder,
                ...partListSearchParams,
            }),
        )
    }

    const loadSearchParams = async () => {
        if (searchParamPage !== `${page}` && (searchParamPage !== null || page !== 1)) {
            dispatch({
                type: storeDispatchTypes.setPageFilterParts,
                value: {
                    page: Number(searchParamPage) > 1 ? Number(searchParamPage) : 1,
                },
            })
        }

        if (
            searchParamWarehouseId !== filterWarehouseId &&
            (searchParamWarehouseId || filterWarehouseId !== undefined)
        ) {
            filterPartsByWarehouseId(searchParamWarehouseId ? searchParamWarehouseId : '')
        }

        if (searchParamFilterDate !== filterDate && (searchParamFilterDate || filterDate !== undefined)) {
            filterPartsByDate(searchParamFilterDate ? searchParamFilterDate : '')
        }

        if (
            searchParamFilterDateField !== filterDateField &&
            (searchParamFilterDateField || filterDateField !== undefined)
        ) {
            filterPartsByDateField(searchParamFilterDateField ? searchParamFilterDateField : '')
        }

        if (searchParamPartName !== partName && (searchParamPartName || partName !== undefined)) {
            filterPartsByPartName(searchParamPartName ? searchParamPartName : '')
        }

        if (searchParamCategoryId !== `${categoryId}` && (searchParamCategoryId || categoryId !== undefined)) {
            filterPartsByCategoryId(searchParamCategoryId ? searchParamCategoryId : '')
        }

        if (searchParamConditionId !== `${conditionId}` && (searchParamConditionId || conditionId !== undefined)) {
            filterPartsByConditionId(searchParamConditionId ? searchParamConditionId : '')
        }

        if (searchParamTypeId !== `${typeId}` && (searchParamTypeId || typeId !== undefined)) {
            filterPartsByTypeId(searchParamTypeId ? searchParamTypeId : '')
        }

        if (searchParamMarkId !== `${markId}` && (searchParamMarkId || markId !== undefined)) {
            filterPartsByMarkId(searchParamMarkId ? searchParamMarkId : '')
        }

        if (searchParamModelId !== `${modelId}` && (searchParamModelId || modelId !== undefined)) {
            filterPartsByModelId(searchParamModelId ? searchParamModelId : '')
        }

        if (
            searchParamPriceFrom !== `${priceFrom}` ||
            (searchParamPriceFrom === null && priceFrom !== undefined) ||
            searchParamPriceTo !== `${priceTo}` ||
            (searchParamPriceTo === null && priceTo !== undefined)
        ) {
            if (searchParamPriceFrom || priceFrom !== undefined || searchParamPriceTo || priceTo !== undefined) {
                filterPartsByPriceRange(searchParamPriceFrom, searchParamPriceTo)
            }
        }

        if (
            searchParamQuantityFrom !== `${quantityFrom}` ||
            (searchParamQuantityFrom === null && quantityFrom !== undefined) ||
            searchParamQuantityTo !== `${quantityTo}` ||
            (searchParamQuantityTo === null && quantityTo !== undefined)
        ) {
            if (
                searchParamQuantityFrom ||
                quantityFrom !== undefined ||
                searchParamQuantityTo ||
                quantityTo !== undefined
            ) {
                dispatch({
                    type: storeDispatchTypes.setQuantityRangeParts,
                    value: {
                        from: searchParamQuantityFrom,
                        to: searchParamQuantityTo,
                    },
                })
            }
        }

        if (searchParamPartNumber !== `${partNumber}` && (searchParamPartNumber || partNumber !== undefined)) {
            filterPartsByPartNumber(searchParamPartNumber ? searchParamPartNumber : '')
        }

        if (
            searchParamWarehouseSection !== `${warehouseSection}` &&
            (searchParamWarehouseSection || warehouseSection !== undefined)
        ) {
            dispatch({
                type: storeDispatchTypes.setAnyTextFilterParts,
                value: {
                    key: 'warehouseSection',
                    value: searchParamWarehouseSection ? searchParamWarehouseSection : '',
                },
            })
        }

        if (
            searchParamWarehousePlace !== `${warehousePlace}` &&
            (searchParamWarehousePlace || warehousePlace !== undefined)
        ) {
            dispatch({
                type: storeDispatchTypes.setAnyTextFilterParts,
                value: {
                    key: 'warehousePlace',
                    value: searchParamWarehousePlace ? searchParamWarehousePlace : '',
                },
            })
        }

        if (searchParamSortOrder && searchParamSortOrder !== sortOrder.map(pair => pair.join(',')).join(',')) {
            const searchParamsSet = new Set(searchParamSortOrder.match(/[^,]+,[^,]+/g))
            const sortOrderSet = new Set(sortOrder.map(pair => pair.join(',')))

            // Для каждой пары из sortOrder, которая не содержится в searchParamSortOrder
            sortOrder.forEach(pair => {
                const pairString = pair.join(',')
                if (!searchParamsSet.has(pairString)) {
                    filterPartsBySortOrder(pair[0], 'NONE')
                }
            })

            // Для каждой пары из searchParamSortOrder, которая не содержится в sortOrder
            searchParamsSet.forEach(param => {
                if (!sortOrderSet.has(param)) {
                    const [field, order] = param.split(',')
                    filterPartsBySortOrder(field, order)
                }
            })
        } else if (!searchParamSortOrder) {
            for (const field of sortOrder) {
                filterPartsBySortOrder(field[0], 'NONE')
            }
        }

        if (searchParamCarId !== `${carFilter?.carId[0]}`) {
            if (!searchParamCarId) {
                dispatch({ type: storeDispatchTypes.resetCarFilterParts })
            } else {
                if (userId) {
                    const car = await getCarById(searchParamCarId, userId)
                    if (car) {
                        dispatch({
                            type: storeDispatchTypes.setCarFilterParts,
                            value: {
                                car: {
                                    carId: [car.id],
                                    markTitle: car.markTitle,
                                    modelTitle: car.modelTitle,
                                    year: car.year,
                                },
                            },
                        })
                    }
                }
            }
        } else if (!carFilter?.carId[0]) {
            dispatch({ type: storeDispatchTypes.resetCarFilterParts })
        }

        if (searchParamDocumentId !== documentId && (searchParamDocumentId || documentId !== undefined)) {
            dispatch({
                type: storeDispatchTypes.setDocumentFilterParts,
                value: {
                    document: {
                        documentId: searchParamDocumentId,
                    },
                },
            })
        }

        if (searchParamWithPrice !== String(withPrice) && (searchParamWithPrice || withPrice !== undefined)) {
            dispatch({
                type: storeDispatchTypes.setWithPriceParts,
                value: {
                    withPrice: searchParamWithPrice === 'true',
                },
            })
        }

        if (searchParamWithPhoto !== String(withPhoto) && (searchParamWithPhoto || withPhoto !== undefined)) {
            let newValue: boolean | undefined
            if (searchParamWithPhoto === 'true') {
                newValue = true
            } else if (searchParamWithPhoto === 'false') {
                newValue = false
            } else {
                newValue = undefined
            }
            
            dispatch({
                type: storeDispatchTypes.setWithPhotoParts,
                value: {
                    withPhoto: newValue,
                },
            })
        }

        if (
            searchParamWithDescription !== String(withDescription) &&
            (searchParamWithDescription || withDescription !== undefined)
        ) {
            dispatch({
                type: storeDispatchTypes.setWithDescriptionParts,
                value: {
                    withDescription: searchParamWithDescription === 'true',
                },
            })
        }

        if (
            searchParamWithPartNumber !== String(withPartNumber) &&
            (searchParamWithPartNumber || withPartNumber !== undefined)
        ) {
            dispatch({
                type: storeDispatchTypes.setWithPartNumberParts,
                value: {
                    withPartNumber: searchParamWithPartNumber === 'true',
                },
            })
        }

        if (
            searchParamWithMarkModelModificationAndTypeId !== String(withMarkModelModificationAndTypeId) &&
            (searchParamWithMarkModelModificationAndTypeId || withMarkModelModificationAndTypeId !== undefined)
        ) {
            dispatch({
                type: storeDispatchTypes.setWithMarkModelModificationAndTypeIdParts,
                value: {
                    withMarkModelModificationAndTypeId: searchParamWithMarkModelModificationAndTypeId === 'true',
                },
            })
        }

        if (searchParamWithCarId !== String(withCarId) && (searchParamWithCarId || withCarId !== undefined)) {
            dispatch({
                type: storeDispatchTypes.setWithCarId,
                value: {
                    withCarId: searchParamWithCarId === 'true',
                },
            })
        }

        if (
            searchParamWithAvitoFullInfo !== String(withAvitoFullInfo) &&
            (searchParamWithAvitoFullInfo || withAvitoFullInfo !== undefined)
        ) {
            dispatch({
                type: storeDispatchTypes.setWithAvitoFullInfo,
                value: {
                    withAvitoFullInfo: searchParamWithAvitoFullInfo === 'true',
                },
            })
        }

        if (searchParamMarketplace !== marketplace && (searchParamMarketplace || marketplace !== undefined)) {
            filterPartsByMarketplace(searchParamMarketplace as MarketplacesKeys || null)
        }

        setSearchParamsLoaded(1)
    }

    // pre-load marketplaces list
    useEffect(() => {
        dispatch(getMarketplacesInfo())
    }, [])

    // Загрузка параметров из строки поиска
    useEffect(() => {
        loadSearchParams()
    }, [searchParams])

    // Загрузка параметров в строку поиска
    useEffect(() => {
        if (!searchParamsLoaded) {
            return
        }

        // Текущие параметры
        const currentPage = page > 1 ? `${page}` : null
        const currentCarId = carFilter?.carId ? `${carFilter.carId}` : null
        const currentFilterDate = filterDate ? `${filterDate}` : null
        const currentFilterDateField = filterDateField ? `${filterDateField}` : null
        const currentWarehouseId = filterWarehouseId ? `${filterWarehouseId}` : null
        const currentPartName = partName ? `${partName}` : null
        const currentCategoryId = categoryId ? `${categoryId}` : null
        const currentConditionId = conditionId ? `${conditionId}` : null
        const currentTypeId = typeId ? `${typeId}` : null
        const currentMarkId = markId ? `${markId}` : null
        const currentModelId = modelId ? `${modelId}` : null
        const currentPriceFrom = priceFrom !== undefined ? `${priceFrom}` : null
        const currentPriceTo = priceTo !== undefined ? `${priceTo}` : null
        const currentPartNumber = partNumber ? `${partNumber}` : null
        const currentSortOrder = sortOrder.length ? sortOrder : null
        const currentDocumentId = documentId ? `${documentId}` : null
        const currentWithPrice = withPrice !== undefined ? `${withPrice}` : null
        const currentWithPhoto = withPhoto !== undefined ? `${withPhoto}` : null
        const currentWithDescription = withDescription !== undefined ? `${withDescription}` : null
        const currentWithPartNumber = withPartNumber !== undefined ? `${withPartNumber}` : null
        const currentWithMarkModelModificationAndTypeId =
            withMarkModelModificationAndTypeId !== undefined ? `${withMarkModelModificationAndTypeId}` : null
        const currentWithCarId = withCarId !== undefined ? `${withCarId}` : null
        const currentWithAvitoFullInfo = withAvitoFullInfo !== undefined ? `${withAvitoFullInfo}` : null
        const currentWarehouseSection = warehouseSection !== undefined ? `${warehouseSection}` : null
        const currentWarehousePlace = warehousePlace !== undefined ? `${warehousePlace}` : null
        const currentQuantityFrom = quantityFrom !== undefined ? `${quantityFrom}` : null
        const currentQuantityTo = quantityTo !== undefined ? `${quantityTo}` : null
        const currentMarketplace = marketplace ? `${marketplace}` : null

        // Проверяем, изменились ли параметры строки поиска
        const pageChanged = searchParamPage !== currentPage
        const carIdChanged = searchParamCarId !== currentCarId
        const filterDateChanged = searchParamFilterDate !== currentFilterDate
        const filterDateChangedField = searchParamFilterDateField !== currentFilterDateField
        const warehouseIdChanged = searchParamWarehouseId !== currentWarehouseId
        const partNameChanged = searchParamPartName !== currentPartName
        const categoryIdChanged = searchParamCategoryId !== currentCategoryId
        const conditionIdChanged = searchParamConditionId !== currentConditionId
        const typeIdChanged = searchParamTypeId !== currentTypeId
        const markIdChanged = searchParamMarkId !== currentMarkId
        const modelIdChanged = searchParamModelId !== currentModelId
        const priceFromChanged = searchParamPriceFrom !== currentPriceFrom
        const priceToChanged = searchParamPriceTo !== currentPriceTo
        const partNumberChanged = searchParamPartNumber !== currentPartNumber
        const documentIdChanged = searchParamDocumentId !== currentDocumentId
        const withPriceChanged = searchParamWithPrice !== currentWithPrice
        const withPhotoChanged = searchParamWithPhoto !== currentWithPhoto
        const withDescriptionChanged = searchParamWithDescription !== currentWithDescription
        const withPartNumberChanged = searchParamWithPartNumber !== currentWithPartNumber
        const withMarkModelModificationAndTypeIdChanged =
            searchParamWithMarkModelModificationAndTypeId !== currentWithMarkModelModificationAndTypeId
        const withCarIdChanged = searchParamWithCarId !== currentWithCarId
        const withAvitoFullInfoChanged = searchParamWithAvitoFullInfo !== currentWithAvitoFullInfo
        const warehouseSectionChanged = searchParamWarehouseSection !== currentWarehouseSection
        const warehousePlaceChanged = searchParamWarehousePlace !== currentWarehousePlace
        const quantityFromChanged = searchParamQuantityFrom !== currentQuantityFrom
        const quantityToChanged = searchParamQuantityTo !== currentQuantityTo
        const marketplaceChanged = searchParamMarketplace !== currentMarketplace

        let sortOrderChanged = false
        if (searchParamSortOrder) {
            const searchParamsSet = new Set(searchParamSortOrder.match(/[^,]+,[^,]+/g))
            const sortOrderSet = new Set(sortOrder.map(pair => pair.join(',')))

            sortOrder.forEach(pair => {
                const pairString = pair.join(',')
                if (!searchParamsSet.has(pairString)) {
                    sortOrderChanged = true
                    return
                }
            })

            searchParamsSet.forEach(param => {
                if (!sortOrderSet.has(param)) {
                    sortOrderChanged = true
                    return
                }
            })
        } else if (!searchParamSortOrder && currentSortOrder) {
            sortOrderChanged = true
        }

        const searchParamsChanged =
            carIdChanged ||
            pageChanged ||
            filterDateChanged ||
            filterDateChangedField ||
            warehouseIdChanged ||
            partNameChanged ||
            categoryIdChanged ||
            conditionIdChanged ||
            typeIdChanged ||
            markIdChanged ||
            modelIdChanged ||
            priceFromChanged ||
            priceToChanged ||
            partNumberChanged ||
            sortOrderChanged ||
            documentIdChanged ||
            withPriceChanged ||
            withPhotoChanged ||
            withDescriptionChanged ||
            withPartNumberChanged ||
            withMarkModelModificationAndTypeIdChanged ||
            withCarIdChanged ||
            withAvitoFullInfoChanged ||
            warehouseSectionChanged ||
            warehousePlaceChanged ||
            quantityFromChanged ||
            quantityToChanged ||
            marketplaceChanged

        if (searchParamsChanged) {
            setSearchParams({
                ...(currentCarId ? { carId: `${currentCarId}` } : {}),
                ...(currentPage ? { p: `${currentPage}` } : {}),
                ...(currentFilterDate ? { d: `${currentFilterDate}` } : {}),
                ...(currentFilterDateField ? { dField: `${currentFilterDateField}` } : {}),
                ...(currentWarehouseId ? { wh: `${currentWarehouseId}` } : {}),
                ...(currentPartName ? { pn: `${currentPartName}` } : {}),
                ...(currentCategoryId ? { g: `${currentCategoryId}` } : {}),
                ...(currentConditionId ? { conditionId: `${currentConditionId}` } : {}),
                ...(currentTypeId ? { typeId: `${currentTypeId}` } : {}),
                ...(currentMarkId ? { markId: `${currentMarkId}` } : {}),
                ...(currentModelId ? { modelId: `${currentModelId}` } : {}),
                ...(currentPriceFrom ? { priceFrom: `${currentPriceFrom}` } : {}),
                ...(currentPriceTo ? { priceTo: `${currentPriceTo}` } : {}),
                ...(currentPartNumber ? { partNumber: `${currentPartNumber}` } : {}),
                ...(sortOrder && sortOrder.length !== 0 ? { sortOrder: `${sortOrder}` } : {}),
                ...(currentDocumentId ? { documentId: `${currentDocumentId}` } : {}),
                ...(currentWithPrice ? { withPrice: `${currentWithPrice}` } : {}),
                ...(currentWithPhoto ? { withPhoto: `${currentWithPhoto}` } : {}),
                ...(currentWithDescription ? { withDescription: `${currentWithDescription}` } : {}),
                ...(currentWithPartNumber ? { withPartNumber: `${currentWithPartNumber}` } : {}),
                ...(currentWithMarkModelModificationAndTypeId
                    ? {
                          withMarkModelModificationAndTypeId: `${currentWithMarkModelModificationAndTypeId}`,
                      }
                    : {}),
                ...(currentWithCarId ? { withCarId: `${currentWithCarId}` } : {}),
                ...(currentWithAvitoFullInfo ? { withAvitoFullInfo: `${currentWithAvitoFullInfo}` } : {}),
                ...(currentWarehouseSection ? { warehouseSection: `${currentWarehouseSection}` } : {}),
                ...(currentWarehousePlace ? { warehousePlace: `${currentWarehousePlace}` } : {}),
                ...(currentQuantityFrom ? { quantityFrom: `${currentQuantityFrom}` } : {}),
                ...(currentQuantityTo ? { quantityTo: `${currentQuantityTo}` } : {}),
                ...(currentMarketplace ? { marketplace: `${currentMarketplace}` } : {}),
            })
        }

        loadParts()
    }, [
        searchParamsLoaded,
        page,
        perPage,
        sortOrder,
        carFilter?.carId,
        modelId,
        markId,
        categoryId,
        conditionId,
        typeId,
        partName,
        priceFrom,
        priceTo,
        yearFrom,
        yearTo,
        quantityFrom,
        quantityTo,
        partId,
        partNumber,
        filterDate,
        filterWarehouseId,
        documentId,
        withPrice,
        withPhoto,
        withDescription,
        withPartNumber,
        withMarkModelModificationAndTypeId,
        withCarId,
        withAvitoFullInfo,
        warehouseSection,
        warehousePlace,
        marketplace,
    ])

    // load part warehouses data
    useEffect(() => {
        dispatch(warehousesSelectSearch(''))
        dispatch(loadMarketplacesList())
    }, [])

    const getPartById = useCallback(
        async (partId: string) => {
            if (partId) {
                const part = await DatahubApiService.getPartByPartId(partId)

                if (!part) {
                    return
                } else if (!isEditModalOpen) {
                    openEditModal(part)
                }
                setCurrentPart(part)
            }
        },
        [isEditModalOpen, openEditModal, setCurrentPart],
    )

    // open modal by partId
    useEffect(() => {
        if (params.partId) {
            getPartById(params.partId)
        } else {
            setIsEditModalOpen(false)
        }
    }, [params.partId])

    // Промежуточная модалка-подтверждение
    const [isApplyActionModalOpen, setIsApplyActionModalOpen] = useState(false)
    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false)
    const [pendingAction, setPendingAction] = useState<null | ((parts?: Part[]) => void)>(null)
    const [isDisableFilterButton, setIsDisableFilterButton] = useState(false)
    const [modalParts, setModalParts] = useState<Part[]>([])

    const handleActionWithScopeSelection = (action: (parts?: Part[]) => void, disableFilterButton: boolean = false) => {
        setPendingAction(() => action)

        if (!selectAll) {
            setModalParts(selectedParts)
            setIsConfirmModalOpen(true)
            return
        }

        setIsDisableFilterButton(disableFilterButton)
        setIsApplyActionModalOpen(true)
    }

    const handleApplyForPage = () => {
        setModalParts(parts)
        setIsApplyActionModalOpen(false)
        setIsConfirmModalOpen(true)
    }

    const handleApplyForFilter = () => {
        setModalParts([])
        setIsApplyActionModalOpen(false)
        setIsConfirmModalOpen(true)
    }

    const handleConfirmAction = () => {
        if (pendingAction) pendingAction(modalParts)
        setIsConfirmModalOpen(false)
    }

    // Выбранные запчасти в чекбоксах
    const [checksFromModalSellParts, setChecksFromModalSellParts] = useState<{
        documentType: EDocumentType[]
        marketplace?: string
        deal?: any
    }>({
        documentType: [],
        marketplace: '',
        deal: {},
    })
    const selectAll = useSelector(state => state.partList.selectedParts.selectAll)
    const selectedParts = useSelector(state => state.partList.selectedParts.parts)

    const handleCheckboxChange = (part: Part) => {
        const newCheckedParts = [...selectedParts]
        const partIndex = newCheckedParts.findIndex(p => p.id === part.id)

        if (partIndex !== -1) {
            newCheckedParts.splice(partIndex, 1)
        } else {
            newCheckedParts.push(part)
        }

        dispatch({
            type: storeDispatchTypes.setSelectedParts,
            value: newCheckedParts,
        })
    }

    const handleAllCheckboxCancel = () => {
        setModalParts([])
        dispatch({
            type: storeDispatchTypes.setSelectAllParts,
            value: false,
        })
    }

    const confirmModalMarketplacesChanges = async (partsId: string[], checkedMarketplaces: Record<string, boolean>) => {
        try {
            if (!modalParts.length) {
                await dispatch(updatePartsMarketplaces(partsId, checkedMarketplaces, partListSearchParams))
            } else {
                await dispatch(updatePartsMarketplaces(partsId, checkedMarketplaces))
            }
            toast.success('Запчасти успешно привязаны')
        } catch (error) {
            toast.error(`Не удалось привязать к маркетплейсам`)
            console.error('Ошибка при привязке к маркетплейсам', error)
        }
        loadParts()
    }

    // Главный поиск
    const setNameSearch = (searchTerm: string) => {
        dispatch({
            type: storeDispatchTypes.setPartNameTextFilterParts,
            value: {
                partName: searchTerm,
            },
        })
    }

    const [
        setPartsArchivedStatusHandler,
        { data: dataSetPartsArchivedStatusHandler, isError: isErrorSetPartsArchivedStatusHandler },
    ] = useSetPartsArchivedStatusHandlerMutation()

    const handleSetPartsArchivedStatus = (parts?: Part[]) => {
        const partsId = parts?.map(part => part.id)
        setPartsArchivedStatusHandler({
            partsId: parts?.length ? partsId : undefined,
            newArchivedStatus: true,
            params: !parts?.length ? partListSearchParams : undefined,
        })
            .unwrap()
            .then(response => {
                if (response.status === 'ok') {
                    loadParts()
                }
            })

        handleAllCheckboxCancel()
    }

    useToast({
        isTriggered: !!dataSetPartsArchivedStatusHandler,
        type: ToastType.SUCCESS,
        message: `Запчасти успешно отправлены в архив`,
    })
    useToast({
        isTriggered: isErrorSetPartsArchivedStatusHandler,
        type: ToastType.ERROR,
        message: `Ошибка отправки запчастей в архив`,
    })

    useEffect(() => {
        dispatch(getUserActiveColumnsPartList())
    }, [])

    // Добавление номеров приходных накладных для загруженных деталей
    useEffect(() => {
        if (isLoading) return
        if (parts.length) {
            dispatch(getIncomingInvoicesByPartsId(parts.map(part => part.id)))
        }
    }, [isLoading])

    // Сброс фильтров при уходе со страницы
    useResetFiltersOnUnmount()

    return (
        <div className={styles.wrap}>
            <ToastContainer position="bottom-center" autoClose={5000} />
            {/* Модалки */}
            {currentPart && isEditModalOpen && (
                <ModalEditPart
                    part={currentPart}
                    isOpen={isEditModalOpen}
                    closeModal={() => {
                        handleClose()
                        setCurrentPart()
                    }}
                    confirmChanges={() => {
                        handleAllCheckboxCancel()
                        loadParts()
                    }}
                />
            )}
            {isSellPartModalOpen && soldPart && (
                <ModalFastDeal
                    parts={[soldPart]}
                    isOpen={isSellPartModalOpen}
                    closeModal={(documentType, marketplace, deal) => {
                        dispatch(setSellPartModal({ part: null, isOpen: false }))
                        if (documentType?.length) {
                            setChecksFromModalSellParts({
                                documentType,
                                marketplace,
                                deal,
                            })
                            setIsDataDocumentModalOpen(true)
                        } else {
                            setCurrentPart()
                            handleAllCheckboxCancel()
                        }
                    }}
                />
            )}
            {isSellPartsModalOpen && (
                <ModalFastDeal
                    parts={modalParts}
                    isOpen={isSellPartsModalOpen}
                    closeModal={(documentType, marketplace, deal) => {
                        setIsSellPartsModalOpen(false)

                        if (documentType?.length) {
                            setChecksFromModalSellParts({
                                documentType,
                                marketplace,
                                deal,
                            })
                            setIsDataDocumentModalOpen(true)
                        } else {
                            handleAllCheckboxCancel()
                        }
                    }}
                />
            )}
            {isDataDocumentModalOpen && (
                <ModalDataDocument
                    isOpen={isDataDocumentModalOpen}
                    closeModal={() => {
                        setCurrentPart()
                        setIsDataDocumentModalOpen(false)
                        handleAllCheckboxCancel()
                        setChecksFromModalSellParts({
                            documentType: [],
                            marketplace: '',
                        })
                    }}
                    checks={checksFromModalSellParts}
                    parts={modalParts}
                />
            )}
            {isIncomingInvoicePartsModalOpen && (
                <ModalIncomingInvoiceOpen
                    isOpen={isIncomingInvoicePartsModalOpen}
                    closeModal={() => {
                        setIsIncomingInvoicePartsModalOpen(false)
                        handleAllCheckboxCancel()
                    }}
                    parts={modalParts}
                />
            )}
            {isLinkingToCarPartsModalOpen && (
                <ModalLinkingToCar
                    isOpen={isLinkingToCarPartsModalOpen}
                    closeModal={() => {
                        setIsLinkingToCarPartsModalOpen(false)
                        handleAllCheckboxCancel()
                    }}
                    parts={modalParts}
                    confirmChanges={() => loadParts()}
                    partListSearchParams={!modalParts.length ? partListSearchParams : undefined}
                />
            )}
            {isMarketplacesModalOpen && (
                <ModalMarketplaces
                    isOpen={isMarketplacesModalOpen}
                    closeModal={() => {
                        setIsMarketplacesModalOpen(false)
                        handleAllCheckboxCancel()
                    }}
                    parts={modalParts}
                    count={modalParts.length || itemsCount}
                    confirmChanges={confirmModalMarketplacesChanges}
                    loadPartsMarketplacesCount={async () =>
                        await dispatch(getPartsMarketplacesCount(partListSearchParams))
                    }
                />
            )}
            {isCustomizableColumnsModalOpen && (
                <ModalCustomizableColumns
                    isOpen={isCustomizableColumnsModalOpen}
                    closeModal={() => setIsCustomizableColumnsModalOpen(false)}
                    customizableColumns={customizableColumns}
                />
            )}
            {isChangeCarDataModalOpen && (
                <ModalChangeCarData
                    isOpen={isChangeCarDataModalOpen}
                    closeModal={() => {
                        setIsChangeCarDataModalOpen(false)
                        handleAllCheckboxCancel()
                    }}
                    parts={modalParts}
                    confirmChanges={() => loadParts()}
                    partListSearchParams={!modalParts.length ? partListSearchParams : undefined}
                />
            )}
            {isChangePartTypeDataModalOpen && (
                <ModalChangePartTypeData
                    isOpen={isChangePartTypeDataModalOpen}
                    closeModal={() => {
                        setIsChangePartTypeDataModalOpen(false)
                        handleAllCheckboxCancel()
                    }}
                    parts={modalParts}
                    confirmChanges={() => loadParts()}
                    partListSearchParams={!modalParts.length ? partListSearchParams : undefined}
                />
            )}
            {isChangePartWarehouseDataModalOpen && (
                <ModalLinkToWarehouse
                    isOpen={isChangePartWarehouseDataModalOpen}
                    closeModal={() => {
                        setIsChangePartWarehouseDataModalOpen(false)
                        handleAllCheckboxCancel()
                    }}
                    parts={modalParts}
                    confirmChanges={() => loadParts()}
                    partListSearchParams={!modalParts.length ? partListSearchParams : undefined}
                />
            )}
            {isApplyActionModalOpen && (
                <ModalPartsBulkApply
                    isOpen={isApplyActionModalOpen}
                    onClose={() => setIsApplyActionModalOpen(false)}
                    onApplyForPage={handleApplyForPage}
                    onApplyForFilter={handleApplyForFilter}
                    disableFilterButton={isDisableFilterButton}
                />
            )}
            {isConfirmModalOpen && (
                <ModalPartsBulkConfirm
                    isOpen={isConfirmModalOpen}
                    onClose={() => {
                        handleAllCheckboxCancel()
                        setIsConfirmModalOpen(false)
                    }}
                    onConfirm={handleConfirmAction}
                    partsCount={selectAll ? modalParts.length || itemsCount : selectedParts.length}
                />
            )}
            {isChangeDimensionsAndWeightModalOpen && (
                <ModalChangeDimensionsAndWeight
                    isOpen={isChangeDimensionsAndWeightModalOpen}
                    closeModal={() => {
                        setIsChangeDimensionsAndWeightModalOpen(false)
                        handleAllCheckboxCancel()
                    }}
                    parts={modalParts}
                    confirmChanges={() => loadParts()}
                    partListSearchParams={!modalParts.length ? partListSearchParams : undefined}
                />
            )}
            {isChangeConditionModalOpen && (
                <ModalChangeCondition
                    isOpen={isChangeConditionModalOpen}
                    closeModal={() => {
                        setIsChangeConditionModalOpen(false)
                        handleAllCheckboxCancel()
                    }}
                    parts={modalParts}
                    confirmChanges={() => loadParts()}
                    partListSearchParams={!modalParts.length ? partListSearchParams : undefined}
                />
            )}
            {isChangeBrandModalOpen && (
                <ModalChangeBrand
                    isOpen={isChangeBrandModalOpen}
                    closeModal={() => {
                        setIsChangeBrandModalOpen(false)
                        handleAllCheckboxCancel()
                    }}
                    parts={modalParts}
                    confirmChanges={() => loadParts()}
                    partListSearchParams={!modalParts.length ? partListSearchParams : undefined}
                />
            )}
            {isChangePriceModalOpen && (
                <ModalChangePrice
                    isOpen={isChangePriceModalOpen}
                    closeModal={() => {
                        setIsChangePriceModalOpen(false)
                        handleAllCheckboxCancel()
                    }}
                    parts={modalParts}
                    confirmChanges={() => loadParts()}
                    partListSearchParams={!modalParts.length ? partListSearchParams : undefined}
                />
            )}
            {isChangeWarehouseLocationModalOpen && (
                <ModalChangeWarehouseLocation
                    isOpen={isChangeWarehouseLocationModalOpen}
                    closeModal={() => {
                        setIsChangeWarehouseLocationModalOpen(false)
                        handleAllCheckboxCancel()
                    }}
                    parts={modalParts}
                    confirmChanges={() => loadParts()}
                    partListSearchParams={!modalParts.length ? partListSearchParams : undefined}
                />
            )}

            <div className={styles.rowWrap}>
                <SalesText
                    text={'Запчасти'}
                    fontWeight={fontWeights.bold}
                    fontSize={fontSizes.xxl}
                    letterSpacing={-0.02}
                />
            </div>
            <div className={styles.rowWrap}>
                <SearchComponent
                    oldSearchTerm={partName}
                    setSearchTerm={setNameSearch}
                    resultCount={itemsCount !== itemsTotal ? itemsCount : undefined}
                />
                <SalesButton
                    borderRadius={10}
                    backgroundColor={colors.blueLight}
                    paddingHorizontalPixels={20}
                    paddingVerticalPixels={6}
                    onClick={() => navigate(getAdminNavigationPath(adminRouteAlias.newPart.location))}
                >
                    <>
                        <PlusLg size={24} color={colors.white} />
                        <SalesText
                            text={'Добавить запчасть'}
                            marginLeftPixels={10}
                            fontSize={fontSizes.s}
                            color={colors.white}
                        />
                    </>
                </SalesButton>
            </div>
            <div className={styles.rowWrap}>
                <Dropdown className={styles.customDropdown}>
                    <Dropdown.Toggle disabled={!parts.length || (selectedParts.length == 0 && !selectAll)}>
                        Массовые действия
                        {!!(selectAll || selectedParts.length) && (
                            <span style={{ marginLeft: '8px' }}>{selectAll ? itemsCount : selectedParts.length}</span>
                        )}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <Dropdown.Item
                            onClick={() => handleActionWithScopeSelection(() => setIsSellPartsModalOpen(true), true)}
                        >
                            Продать
                        </Dropdown.Item>
                        <Dropdown.Item
                            onClick={() => {
                                handleActionWithScopeSelection(handleSetPartsArchivedStatus)
                            }}
                        >
                            В архив
                        </Dropdown.Item>
                        <Dropdown.Item
                            onClick={() =>
                                handleActionWithScopeSelection(() => setIsIncomingInvoicePartsModalOpen(true), true)
                            }
                        >
                            В приходную накладную
                        </Dropdown.Item>
                        <Dropdown.Item
                            onClick={() => handleActionWithScopeSelection(() => setIsLinkingToCarPartsModalOpen(true))}
                        >
                            Привязать к автомобилю
                        </Dropdown.Item>
                        <Dropdown.Item
                            onClick={() => handleActionWithScopeSelection(() => setIsMarketplacesModalOpen(true))}
                        >
                            Маркетплейсы
                        </Dropdown.Item>
                        <Dropdown.Item
                            onClick={() => handleActionWithScopeSelection(() => setIsChangeCarDataModalOpen(true))}
                        >
                            Марка/модель/поколение/модификация
                        </Dropdown.Item>
                        <Dropdown.Item
                            onClick={() => handleActionWithScopeSelection(() => setIsChangePartTypeDataModalOpen(true))}
                        >
                            Изменить категорию
                        </Dropdown.Item>
                        <Dropdown.Item
                            onClick={() =>
                                handleActionWithScopeSelection(() => setIsChangePartWarehouseDataModalOpen(true))
                            }
                        >
                            Привязать к складу
                        </Dropdown.Item>
                        <Dropdown.Item
                            onClick={() =>
                                handleActionWithScopeSelection(() => setIsChangeWarehouseLocationModalOpen(true))
                            }
                        >
                            Ряд/Полка/Место/Секция
                        </Dropdown.Item>
                        <Dropdown.Item
                            onClick={() =>
                                handleActionWithScopeSelection(() => setIsChangeDimensionsAndWeightModalOpen(true))
                            }
                        >
                            Изменить габариты и вес с упаковкой
                        </Dropdown.Item>
                        <Dropdown.Item
                            onClick={() => handleActionWithScopeSelection(() => setIsChangeConditionModalOpen(true))}
                        >
                            Изменить состояние
                        </Dropdown.Item>
                        <Dropdown.Item
                            onClick={() => handleActionWithScopeSelection(() => setIsChangeBrandModalOpen(true))}
                        >
                            Изменить бренд
                        </Dropdown.Item>
                        <Dropdown.Item
                            onClick={() => handleActionWithScopeSelection(() => setIsChangePriceModalOpen(true))}
                        >
                            Изменить цены
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
                <NavigationButtons
                    pages={pagesParts}
                    currentPage={getAdminNavigationPath(adminRouteAlias.parts.location)}
                    counts={counts}
                    navigate={navigate}
                />
                {warehousesSS.length > 0 && (
                    <Dropdown className={styles.filterDropdown}>
                        <Dropdown.Toggle>
                            {filterWarehouseId === 'null'
                                ? 'Без склада'
                                : filterWarehouseId
                                  ? warehousesSS.find(w => String(w.value) === filterWarehouseId)?.name ||
                                    filterWarehouseId
                                  : 'Выбрать склад'}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item onClick={() => filterPartsByWarehouseId('')}>Все</Dropdown.Item>
                            <Dropdown.Item onClick={() => filterPartsByWarehouseId('null')}>Без склада</Dropdown.Item>
                            {warehousesSS.map(w => (
                                <Dropdown.Item
                                    key={String(w.value)}
                                    onClick={() => filterPartsByWarehouseId(String(w.value))}
                                >
                                    {w.name}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                )}
                <Dropdown className={styles.filterDropdown}>
                    <Dropdown.Toggle>{marketplace ? Marketplaces[marketplace] : 'Выбрать маркетплейс'}</Dropdown.Toggle>

                    <Dropdown.Menu>
                        <Dropdown.Item onClick={() => filterPartsByMarketplace(null)}>Все</Dropdown.Item>
                        {Object.entries(Marketplaces).map(([key, value]) => (
                            <Dropdown.Item key={key} onClick={() => filterPartsByMarketplace(key as MarketplacesKeys)}>
                                {value}
                            </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                </Dropdown>
                <SalesButton
                    borderRadius={10}
                    hoverBackgroundColor={colors.grayLighter}
                    paddingHorizontalPixels={20}
                    paddingVerticalPixels={7}
                    marginLeftAuto
                    onClick={() => setIsCustomizableColumnsModalOpen(true)}
                >
                    <img src={gear} alt="gear" className={styles.icon} />
                </SalesButton>
                {!isLoading && parts.length === 0 ? (
                    <></>
                ) : (
                    <div>
                        <ListPagination
                            page={page}
                            setPage={page =>
                                dispatch({
                                    type: storeDispatchTypes.setPageFilterParts,
                                    value: { page },
                                })
                            }
                            perPage={perPage}
                            itemsCount={itemsCount}
                        />
                    </div>
                )}
            </div>
            {carFilter && (
                <div className={styles.rowWrap}>
                    <Link
                        to={`${getAdminNavigationPath(adminRouteAlias.cars.location)}/${carFilter?.carId}`}
                        style={{ textDecoration: 'none' }}
                    >
                        <SalesButton borderRadius={10} paddingHorizontalPixels={20} paddingVerticalPixels={7}>
                            <SalesText
                                text={`Перейти к авто ${carFilter?.markTitle} ${carFilter?.modelTitle} ${carFilter?.year}`}
                                fontSize={fontSizes.s}
                            />
                        </SalesButton>
                    </Link>
                </div>
            )}
            <TablePartList
                columns={customizableColumns}
                parts={parts}
                isLoading={isLoading}
                selectAll={selectAll}
                selectedParts={selectedParts}
                handleCheckboxChange={handleCheckboxChange}
                openEditModal={openEditModal}
            />
            {!isLoading && parts.length === 0 ? (
                <ListNoItems slice={'partList'} />
            ) : (
                <ListPagination
                    page={page}
                    setPage={page =>
                        dispatch({
                            type: storeDispatchTypes.setPageFilterParts,
                            value: { page },
                        })
                    }
                    perPage={perPage}
                    itemsCount={itemsCount}
                    justifyContent={'flex-end'}
                />
            )}
        </div>
    )
}

export default PartList
